import queryString from 'query-string'

const getQueryParams = () => {
    return queryString.parse(window.location.search)
}

export const goToMyDances = (history, user) => {
    if (!user) {
        history.push({
            pathname: '/dances',
        })
    }
    history.push({
        pathname: '/dances/',
        state: {
            searchByUser: {
                id: user.user_id,
                first_name: user.first_name,
                last_name: user.last_name,
            },
        },
    })
}
export const goToDances = (history, user) => {
    if (user?.is_admin) {
        history.push({
            pathname: '/dances/',
            state: {
                searchByOrderStratus: {
                    label: 'מוזמן',
                    value: 'מוזמן',
                },
            },
        })
    } else {
        goToMyDances(user)
    }
}

const redirectToPreviousUrl = (newUrl) => {
    const dancesLocation = '/dances'
    newUrl && localStorage.setItem('@markidim:filter_state', newUrl)
    const paramsString =
        newUrl || localStorage.getItem('@markidim:filter_state')
    const currentLocation = window.location.pathname
    window.history.pushState(
        { search: paramsString },
        null,
        window.location.protocol +
            '//' +
            window.location.host +
            dancesLocation +
            '/?' +
            paramsString
    )
    if (currentLocation !== dancesLocation) window.location.reload()
}

const buildQueryParams = (params) => {
    console.log('params = ', params)
    return queryString.stringify(params)
}
const setQueryParams = (params) => {
    const newParams = {}
    const oldParams = getQueryParams()

    Object.keys(params).forEach((k) => {
        if (oldParams[k] + '' !== params[k] + '') {
            newParams[k] = params[k]
        }
    })

    if (Object.keys(newParams).length > 0) {
        const paramsString = queryString.stringify(
            Object.assign({}, getQueryParams(window.location), newParams)
        )
        localStorage.setItem('@markidim:filter_state', paramsString)
        window.history.pushState(
            { search: paramsString },
            null,
            window.location.protocol +
                '//' +
                window.location.host +
                window.location.pathname +
                '?' +
                paramsString
        )
    }
}
const clearQueryParams = () => setQueryParams({})
const goBackToRI = (history) => {
    const returnToIndex = getQueryParams().ri
    const currentLocation = history.length + 1
    const numOfStepsToGoBack = currentLocation - returnToIndex
    history.goBack(numOfStepsToGoBack)
}
const goBackToRD = (history) => {
    const returnToIndex = getQueryParams().rd
    const currentLocation = history.length + 1
    const numOfStepsToGoBack = currentLocation - returnToIndex
    history.goBack(numOfStepsToGoBack)
}

const goBackToRS = (history) => {
    const returnToIndex = getQueryParams().rs
    const currentLocation = history.length + 1
    const numOfStepsToGoBack = currentLocation - returnToIndex
    history.goBack(numOfStepsToGoBack)
}

export default {
    getQueryParams,
    buildQueryParams,
    setQueryParams,
    clearQueryParams,
    goBackToRI,
    goBackToRD,
    goBackToRS,
    redirectToPreviousUrl,
    goToDances,
    goToMyDances,
}
